<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 30/11/2021
  -->

<template>
	<div class="qw-input-root qw-special qw-input inline-block"
		 v-bind="attrsStylesClass"
	:class="rootClassesComputed">
		<el-input
				  v-model="valueData"
				  :type="typeComputed"
				  :autosize="multiline ? {minRows} : $attrs.autosize"
				  v-bind="{
                  	...attrsNoStylesClass,
                  	onInput: notifyValueChanged,
                  	'change:modelValue': notifyValueChanged,
                  	onChange: onChangeEvent,
                  	onBlur: $attrs.onBlur ? $attrs.onBlur : onBlur
                  }"
				  :prefixIcon="prefixIcon"
				  :class="inputClassesComputed"
				  :readonly="readonly"
				  :disabled="disabled">

			<template #append v-if="showEyeIcon || $slots.append">
				<qw-button-icon v-if="showEyeIcon" icon="icon-eye" style="color: inherit"
								@mousedown="setShowPassword(true)"
								@mouseup="setShowPassword(false)"></qw-button-icon>

				<div v-else-if="$slots.append">
					<slot name="append"></slot>
				</div>
			</template>

		</el-input>

	</div>
</template>

<script>

import DebouncedVModelView from "@/core/components/DebouncedVModelView.vue";

export default {
	name: "qw-input",
	extends: DebouncedVModelView,
	inheritAttrs: false,

	props: {
		showDivider: {Boolean, default: true},
		showDividerOnHover: {Boolean, default: false},
		borderDotted: {Boolean, default: false},
		readonly: {Boolean, default: false},
		disabled: {Boolean, default: false},
		inputDebounceDelay: Number,
		multiline: Boolean,
		prefixIcon: String,
		minRows: {Number, default: 1},
		autofocus: Boolean,
		autoSelectOnFocus: Boolean,
		hideBackground: Boolean,
		styleProps: {
			Object, default: () => {
			}
		}
	},


	data() {
		return {
			showEyeIcon: false,
			showPassword: false
		}
	},

	mounted() {
		if (this.autofocus) {
			this.focus()
		}
	},

	methods: {

		onBlur(){
			console.log("QwInput: onBlur: ", this.valueData)
			return this.notifyValueChangedImmediate()
		},

		setShowPassword(show) {
			this.showPassword = show
		},

		getInput() {
			return this.$el.getElementsByTagName("input")[0]
		},

		focus() {
			this.getInput().focus()
			if (this.autoSelectOnFocus) {
				setTimeout(() => {
					this.getInput().select()
				})
			}
		},

		selectAll() {
			this.getInput().select()
		},

		onChangeEvent() {
			console.log("QwInput: onChangeEvent: ", this.valueData)
			this.notifyValueChangedImmediate()
		},

		formatDataOut(data) {
			if (this.$attrs.type === "number") {
				data = Number(data)
			}
			return data
		},

		setShowEyeIcon(show) {
			this.showEyeIcon = show
		}

	},


	computed: {
		canFocus() {
			let res = !this.readonly && !this.disabled
			// console.log("canFocus = ", res, ", this.readonly = ", this.readonly, ", this.disabled = ", this.disabled)
			return res
		},

		stylePropsStr() {
			return JSON.stringify(this.styleProps).replaceAll('"', "").replaceAll(',', ";")
		},

		typeComputed() {
			this.setShowEyeIcon(false)
			if (this.multiline) {
				return 'textarea'
			}
			if (this.$attrs.type === 'password-show') {
				this.setShowEyeIcon(true)
				if (this.showPassword) {
					return "text"
				}
				return "password"
			}

			return this.$attrs.type
		},

		attrsComputed(){
			let {class: clazz, style, ...restAttrs} = this.$attrs

			let root = {class: clazz, style}
			let inner = restAttrs

			return {root, inner}
		},

		rootClassesComputed(){
			return [{
				'readonly': this.readonly,
				'input-background': !this.hideBackground,
				'input-disabled': this.disabled,
				'input-background-no-padding': this.readonly,
			}]
		},
		inputClassesComputed(){
			return {
				'show-prefix-icon': !!this.prefixIcon,
				'hide-border': !this.borderDotted && (!this.showDivider || !this.canFocus),
				'border-on-hover': this.showDividerOnHover,
				'borderDotted': this.borderDotted,
				'input-secure': this.$attrs.type === 'secure',
			}
		},
	}
}
</script>

<!--@import "../assets/scss/vars";-->

<style lang="scss">

//@import "../../../assets/scss/vars.scss";

.qw-input-root.qw-special.qw-input {

	.inline-block {
		display: inline-block;
	}

	.borderDotted {
		input, textarea {
			border-bottom: 1px dotted $border-color-default !important;
		}
	}

	input, textarea {
		transition: none;
		border-bottom: 1px solid;
		border-radius: 0;
		border-color: $border-color-default;
	}

	input:focus, textarea:focus:not(:read-only) {
		transition: none;
		border-color: $border-color-active;
	}

	.hide-border {
		input, textarea {
			border: none !important;
		}
	}

	.border-on-hover {

		input:not(:hover):not(:focus), textarea:not(:hover) {
			border: none !important;
			padding-bottom: 1px;
			//border-color: #00FF00 !important;

		}

		input:hover, textarea:hover {
			//border: inherit;
		}
	}

}

</style>
